
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../../../molecules/organization/FilterContainer.vue";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import InlineFormTreeselect from "../../../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import FormInput from "../../../../../landing/src/molecules/form/FormInput.vue";
import NoRecords from "../../../../../common/src/components/NoRecords.vue";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import { UserFavoriteOrganizationListStore } from "../../../stores/user/UserFavoriteOrganizationListStore";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { UserEditFavoriteStore } from "../../../stores/user/UserEditFavoriteStore";

@Component({
    components: {
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
    },
})
export default class LaunchpadSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    userFavoriteOrganizationListStore: UserFavoriteOrganizationListStore = this.container.get(
        UserFavoriteOrganizationListStore,
    );
    userEditFavoriteStore: UserEditFavoriteStore = this.container.get(UserEditFavoriteStore);

    mounted() {
        this.authStore.me();
        this.userFavoriteOrganizationListStore.load().catch(handleError);
    }

    organizationUrl(organizationId: string) {
        return `/organizations/${organizationId}`;
    }

    isOrganizationFavorite(organizationId: string) {
        return this.authStore.user?.favorites?.organizationIds?.includes(organizationId);
    }

    unfollowOrg(organizationId: string) {
        const indexOf =
            this.authStore.user!.favorites!.organizationIds?.indexOf(organizationId) ?? -1;
        if (indexOf >= 0) {
            this.authStore.user?.favorites?.organizationIds?.splice(indexOf, 1);
        }
        this.userEditFavoriteStore.removeOrganization(organizationId);
    }

    get userAffiliation() {
        return this.authStore.user?.organization?.organizationName ?? "No Affiliations";
    }

    get hasUserAffiliation() {
        return this.authStore.user?.organization;
    }

    get addAffiliationUrl() {
        return `/member/request-affiliation`;
    }
}
